<template>
	<div class="menu_warp">
		<div class="tit_warp">
			<span class="fontSiz14">详情</span>
			<div class="pointer fontSiz14 col-333 fontWeight" @click="closeModal()">
				<span class="iconfont icon-shanchu"></span>
			</div>
		</div>

		<div class="rpt_warp">
			<div class="flex">
				<div class="rpt_tit">挂车基本信息</div>
				<div class="editimg fontSize18">
					<div v-if="vehedit" class="flex">
						<div class="mr-10" @click="veheditsave">保存</div>
						<div @click="veheditChange(false)">取消</div>
					</div>
					<div @click="veheditChange(true)" v-else>编辑</div>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>挂车车牌号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vehNo" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆来源:
						</div>
						<div class="input_box">
							<el-select v-model="vehSource" placeholder="请选择车辆来源" @change="vehSourcechange"
								:disabled="veheditisReadOnly">
								<el-option label="自有" value="0"> </el-option>
								<el-option label="外调" value="1"> </el-option>
								<el-option label="临时" value="2"> </el-option>
							</el-select>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>所属公司:
						</div>
						<div class="input_box">
							<el-select v-model="vehAffOrg" placeholder="请选择所属客商" :disabled="vehOrgdisabled">
								<el-option v-for="item in ProviderList" :key="item.cocId" :label="item.cocName"
									:value="item.cocId" />
							</el-select>
						</div>
					</div>
			
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆类型:
						</div>
						<div class="input_box">
							<el-select v-model="vehType" placeholder="请选择车辆类型" disabled>
								<el-option label="普通货车" value="0" />
								<el-option label="牵引车" value="1" />
								<el-option label="挂车" value="2" />
							</el-select>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车型:
						</div>
						<div class="input_box">
							<el-select v-model="vehFlag" placeholder="请选择车型" :disabled="veheditisReadOnly">
								<el-option label="LNG半挂式运输槽车" value="LNG半挂式运输槽车" />
								<el-option label="LNG集装箱式罐车" value="LNG集装箱式罐车" />
							</el-select>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>能源类型:
						</div>
						<div class="input_box">
							<!-- <el-input type="text" v-model="vehFuelType" placeholder="请输入内容"></el-input> -->
							<el-select v-model="vehFuelType" placeholder="请选择" :disabled="veheditisReadOnly">
								<el-option label="汽油" value="0"> </el-option>
								<el-option label="柴油" value="1"> </el-option>
								<el-option label="电" value="2"> </el-option>
								<el-option label="天然气" value="3"> </el-option>
							</el-select>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车载电话:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vehPhone" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆颜色:
						</div>
						<div class="input_box">
							<el-select v-model="vehColour" placeholder="请选择车辆颜色" :disabled="veheditisReadOnly">
								<el-option label="白色" value="白色"> </el-option>
								<el-option label="红色" value="红色"> </el-option>
								<el-option label="蓝色" value="蓝色"> </el-option>
								<el-option label="其它" value="其它"> </el-option>
							</el-select>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>马力:
						</div>
						<div class="input_box">
							<el-input v-model="vehEnginePower" type="number" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>压力表数量:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vehPiezometerNum" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>安全阀数量:
						</div>
						<div class="input_box">
							<el-input v-model="vehSafetyValveNum" type="number" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>轴数:
						</div>
						<div class="input_box">
							<el-input v-model="vehAxleNum" type="number" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车长:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vehLenght" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车宽:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vehWidth" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车高:
						</div>
						<div class="input_box">
							<el-input v-model="vehHeight" type="number" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
			
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>备注:
						</div>
						<div class="input_box">
							<el-input v-model="vehRemark" type="text" placeholder="请输入内容"
								:readonly="veheditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">挂车行驶证</div>
				<div class="editimg fontSize18">
					<div v-if="vedledit" class="flex">
						<div class="mr-10" @click="vedleditsave">保存</div>
						<div @click="vedleditChange(false)">取消</div>
					</div>
					<div @click="vedleditChange(true)" v-else>编辑</div>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆品牌:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vedlBrand" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆类型:
						</div>
			
						<div class="input_box">
							<el-input type="text" v-model="vedlType" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆所有人:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vedlOwner" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>住址:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vedlAddress" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>使用性质:
						</div>
						<div class="input_box">
							<el-input v-model="vedlUseCharacter" type="text" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆型号:
						</div>
						<div class="input_box">
							<el-input v-model="vedlModel" type="text" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆识别号（VIN）:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vedlFrameNo" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发动机号码:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vedlEngineNo" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>注册日期:
						</div>
						<div class="input_box">
							<el-date-picker v-model="vedlRegisterDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getvedlRegisterDate" :readonly="vedleditisReadOnly">
							</el-date-picker>
						</div>
					</div>
				</div>
			
				<!-- <div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发证日期:
						</div>
						<div class="input_box">
							<el-date-picker v-model="vedlIssueDate" type="date" :clearable="false" placeholder="请选择注册日期"
								@change="getvedlIssueDate" :readonly="vedleditisReadOnly">
							</el-date-picker>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆型号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vedlModel" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>燃油类型:
						</div>
						<div class="input_box">
							<el-input v-model="vedlExpirationDate" type="number" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
			
				</div> -->
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>档案编号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="vedlFileNo" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>核定人数:
						</div>
			
						<div class="input_box">
							<el-input type="number" v-model="vedlSeats" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>总质量（KG）:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vedlGrossWeight" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>整备质量（KG）:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vedlCurbWeight" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>核定载质量（KG）:
						</div>
						<div class="input_box">
							<el-input v-model="vedlCarringWeight" type="number" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>总牵引总质量（KG）:
						</div>
						<div class="input_box">
							<el-input v-model="vedlTowWeight" type="number" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>外廓尺寸长度（MM）:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vedlCargoLength" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>外廓尺寸宽度（MM）:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vedlCargoWidht" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>外廓尺寸高度（MM）:
						</div>
						<div class="input_box">
							<el-input type="number" v-model="vedlCargoHeight" placeholder="请输入内容"
								:readonly="vedleditisReadOnly"></el-input>
						</div>
					</div>
			
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发证日期:
						</div>
						<div class="input_box">
							<el-date-picker v-model="vedlIssueDate" type="date" :clearable="false" placeholder="请选择注册日期"
								@change="getvedlIssueDate" :readonly="vedleditisReadOnly">
							</el-date-picker>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>检验有效期截止时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="vedlExpirationDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getvedlExpirationDate" :readonly="vedleditisReadOnly">
							</el-date-picker>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>强制报废时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="vedlScrappingDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getvedlScrappingDate" :readonly="vedleditisReadOnly">
							</el-date-picker>
						</div>
					</div>
			
				</div>
			
				<div class="input_row2" ref="refvedl">
			
					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>行驶证背面附件:
							</div>
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadvedlBackPic" accept=".jpg,.jpeg,.png" :disabled="vedleditisReadOnly">
								<div class="upRpic_icon_item2" v-if="vedlBackPic == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :data-original="vedlBackPic" :src="vedlBackPic"
										@click="openViewer('vedl')" />
								</div>
							</el-upload>
						</div>
					</div>
			
					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>行驶证正面附件:
							</div>
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadvedlFrontPic" accept=".jpg,.jpeg,.png" :disabled="vedleditisReadOnly">
			
								<div class="upRpic_icon_item2" v-if="vedlFrontPic == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :data-original="vedlFrontPic" :src="vedlFrontPic"
										@click="openViewer('vedl')" />
								</div>
							</el-upload>
						</div>
					</div>
					<div class="input_cell2">
					</div>
				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">挂车道路运输证</div>
				<div class="editimg fontSize18">
					<div v-if="veocedit" class="flex">
						<div class="mr-10" @click="veoceditsave">保存</div>
						<div @click="veoceditChange(false)">取消</div>
					</div>
					<div @click="veoceditChange(true)" v-else>编辑</div>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>运输证号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veocTransportLicense" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>业户名称:
						</div>
			
						<div class="input_box">
							<el-input type="text" v-model="veocAffCom" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>地址:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veocComAddr" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>经营许可证号:
						</div>
						<div class="input_box">
							<el-input v-model="veocBusiLicense" type="text" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆类型:
						</div>
						<div class="input_box">
							<el-input v-model="veocVehType" type="text" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>吨（座）位:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veocTonnage" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>经营范围:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veocBusiScope" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>车辆尺寸（MM）:
						</div>
						<div class="input_box">
							<el-input v-model="veocVehSize" type="text" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>核发机关:
						</div>
						<div class="input_box">
							<el-input v-model="veocInstitutionSeal" type="text" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
				</div>
			
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发证日期:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veocRegisterDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getveocRegisterDate" :readonly="veoceditisReadOnly">
							</el-date-picker>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>有效期至:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veocExpirationDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getveocExpirationDate" :readonly="veoceditisReadOnly">
							</el-date-picker>
						</div>
					</div>
			
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>审验有效期至:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veocVerificationDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getveocVerificationDate" :readonly="veoceditisReadOnly">
							</el-date-picker>
						</div>
					</div>
				</div>
			
				<div class="input_row2">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>技术等级评定:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veocTechLevel" placeholder="请输入内容"
								:readonly="veoceditisReadOnly"></el-input>
						</div>
					</div>
			
					<div class="input_cell2" ref="refveoc">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>道路运输证附件:
							</div>
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadveocPhotoUrl" accept=".jpg,.jpeg,.png" :disabled="veoceditisReadOnly">
								<div class="upRpic_icon_item2" v-if="veocPhotoUrl == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :data-original="veocPhotoUrl" :src="veocPhotoUrl"
										@click="openViewer('veoc')" />
								</div>
							</el-upload>
						</div>
					</div>
					<div class="input_cell">
					</div>
			
				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">挂车产品合格证</div>
				<div class="editimg fontSize18">
					<div v-if="veqcedit" class="flex">
						<div class="mr-10" @click="veqceditsave">保存</div>
						<div @click="veqceditChange(false)">取消</div>
					</div>
					<div @click="veqceditChange(true)" v-else>编辑</div>
				</div>
			</div>
			<div class="rpt_box2">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>资质证号:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veqcNo" placeholder="请输入内容"
								:readonly="veqceditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>发证日期:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veqcRegisterDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getveqcRegisterDate" :readonly="veqceditisReadOnly">
							</el-date-picker>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>开始日期:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veqcStartDate" type="date" :clearable="false" placeholder="请选择注册日期"
								@change="getveqcStartDate" :readonly="veqceditisReadOnly">
							</el-date-picker>
						</div>
					</div>
				</div>

				<div class="input_row2">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>产品合格证截止时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veqcExpirationDate" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getveqcExpirationDate" :readonly="veqceditisReadOnly">
							</el-date-picker>
						</div>
					</div>

					<div class="input_cell2" ref="refveqc">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>产品合格证附件:
							</div>
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadveqcPhotoUrl" accept=".jpg,.jpeg,.png" :disabled="veqceditisReadOnly">
								<div class="upRpic_icon_item2" v-if="veqcPhotoUrl == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :data-original="veqcPhotoUrl" :src="veqcPhotoUrl"
										@click="openViewer('veqc')" />
								</div>
							</el-upload>
						</div>
					</div>

					<div class="input_cell">
					</div>

				</div>
			</div>
		</div>

		<div class="rpt_warp m-top20">
			<div class="flex">
				<div class="rpt_tit">挂车保险信息</div>
				<div class="editimg fontSize18">
					<div v-if="veinedit" class="flex">
						<div class="mr-10" @click="veineditsave">保存</div>
						<div @click="veineditChange(false)">取消</div>
					</div>
					<div @click="veineditChange(true)" v-else>编辑</div>
				</div>
			</div>
			<div class="rpt_box4">
				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>保险公司:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veinCompany" placeholder="请输入内容"
								:readonly="veineditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>联系人:
						</div>

						<div class="input_box">
							<el-input type="text" v-model="veinContact" placeholder="请输入内容"
								:readonly="veineditisReadOnly"></el-input>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>联系电话:
						</div>
						<div class="input_box">
							<el-input type="text" v-model="veinPhone" placeholder="请输入内容"
								:readonly="veineditisReadOnly"></el-input>
						</div>
					</div>
				</div>

				<div class="input_row">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>强险开始时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veinStartDate" type="date" :clearable="false" placeholder="请选择注册日期"
								@change="getveinStartDate" :readonly="veineditisReadOnly">
							</el-date-picker>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>强险到期时间:
						</div>

						<div class="input_box">
							<el-date-picker v-model="veinEndDate" type="date" :clearable="false" placeholder="请选择注册日期"
								@change="getveinEndDate" :readonly="veineditisReadOnly">
							</el-date-picker>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>商业险开始时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veinStartDate1" type="date" :clearable="false"
								placeholder="请选择注册日期" @change="getveinStartDate1" :readonly="veineditisReadOnly">
							</el-date-picker>
						</div>
					</div>
				</div>

				<div class="input_row2" ref="refvein">
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							<span class="col-ff0">*</span>商业险到期时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="veinEndDate1" type="date" :clearable="false" placeholder="请选择注册日期"
								@change="getveinEndDate1" :readonly="veineditisReadOnly">
							</el-date-picker>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>强险附件:
							</div>
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadveinPhotoUrl" accept=".jpg,.jpeg,.png" :disabled="veineditisReadOnly">
								<div class="upRpic_icon_item2" v-if="veinPhotoUrl == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :data-original="veinPhotoUrl" :src="veinPhotoUrl"
										@click="openViewer('vein')" />
								</div>
							</el-upload>
						</div>
					</div>

					<div class="input_cell2">
						<div class="rpic_img_warp flex">
							<div class="fontSize14 col-333">
								<span class="col-ff0">*</span>商业险附件:
							</div>
							<el-upload action="none" :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadveinPhotoUrl1" accept=".jpg,.jpeg,.png"
								:disabled="veineditisReadOnly">
								<div class="upRpic_icon_item2" v-if="veinPhotoUrl1 == ''">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
								<div class="upRpic_icon_item2" v-else>
									<img class="upRpic2_icon" :data-original="veinPhotoUrl1" :src="veinPhotoUrl1"
										@click="openViewer('vein')" />
								</div>
							</el-upload>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div class="btn-box">
			<div class="cancel" @click="closeModal">关闭</div>
		</div>
	</div>

</template>

<script>
	import {
		parseTime,
		formatDatetime,
		imgFileToBase64,
		isIdNo,
		isPhone,
		isChinese,
	} from "@/libs/tools";
	import {
		apiObj
	} from "@/config/api";
	import {
		getCurrentInstance,
		onMounted,
		nextTick,
		toRefs,
		reactive,
		defineComponent,
	} from "vue";
	import Viewer from "viewerjs";
	import "viewerjs/dist/viewer.css";
	export default {
		name: "AddtractionVehicle",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["closeModal", "getData"],
		data() {
			return {
				ProviderList: [], //所属客商
				bcProvinceList: [], //银行省
				bcCityList: [], //银行市
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县
				orgList: [],
				rpicUrl: [], //生活照片
				vedlFrontPic: "", //行驶证正面
				vedlBackPic: "", //行驶证背面
				veocPhotoUrl: "", //道路运输证
				veqcPhotoUrl: "", //合格证
				veinPhotoUrl: "", //强险证
				veinPhotoUrl1: "", //商业险证
				vehedit: false,
				veheditisReadOnly: true,
				vedledit: false,
				vedleditisReadOnly: true,
				veocedit: false,
				veoceditisReadOnly: true,
				veqcedit: false,
				veqceditisReadOnly: true,
				veinedit: false,
				veineditisReadOnly: true,

				vehId: "", //id
				vehNo: "", //挂车车牌号
				vehSource: "0", //车辆来源
				vehOrg: "1", //所属公司
				vehAffOrg: "", //所属机构，外键，客商表或主机构表
				vehAffOrgType: "1", //	//所属机构类型：0客商机构1主机构
				vehColour: "", //车辆颜色
				vehPhone: "18566803731", //车载电话
				vehPiezometerNum: "2", //压力表数量
				vehSafetyValveNum: "2", //安全阀数量
				vehAxleNum: "2", //轴数
				vehLenght: "10", //车长
				vehWidth: "10", //车宽
				vehHeight: "10", //车高
				vehType: "2", //车辆类型 0普通货车 1 牵引车 2 挂车
				vehFlag: "2", //车型
				vehEnginePower: "12", //马力
				vehRiskType: "0", //风险状态
				vehFuelType: "0", //能源类型
				vehRemark: "123", //备注
				vedlType: "2", //行驶证车辆类型
				vedlOwner: "2", //车辆所有人
				vedlAddress: '2', //住址
				vedlUseCharacter: "2", //使用性质
				vedlBrand: "2", //品牌型号
				vedlSeries: "2", //车系
				vedlFrameNo: "2", //车辆识别号（VIN）
				vedlEngineNo: "2", //发动机号码
				vedlRegisterDate: "2025-04-09 16:26:24", //注册日期
				vedlIssueDate: "2025-04-09 16:26:24", //发证日期
				vedlModel: "1", //车辆型号
				vedlFileNo: '1', //档案编号
				vedlSeats: '1', //核定人数
				vedlGrossWeight: "1", //总质量（KG）
				vedlCurbWeight: "1", //整备质量（KG）
				vedlCarringWeight: "1", //核定载质量（KG）
				vedlTowWeight: "1", //总牵引总质量（KG）
				vedlCargoLength: "1", //外廓尺寸（MM）
				vedlCargoWidht: "1", //外廓宽尺寸（米）
				vedlCargoHeight: "1", //外廓高尺寸（米）
				vedlExpirationDate: "2025-04-09 16:26:24", //检验有效期截止时间
				vedlScrappingDate: "2025-04-09 16:26:24", //强制报废时间
				veocTransportLicense: "1", //运输证号
				veocAffCom: "1", //业户名称
				veocComAddr: "1", //地址
				veocBusiLicense: "1", //经营许可证号
				veocVehType: "1", //车辆类型
				veocTonnage: "1", //吨（座）位
				veocBusiScope: "1", //经营范围
				veocVehSize: "1", //车辆尺寸（MM）
				veocRegisterDate: "2025-04-09 16:26:24", //发证日期
				veocExpirationDate: "2025-04-09 16:26:24", //有效期至
				veocInstitutionSeal: "1", //核发机关
				veocVerificationDate: "2025-04-09 16:26:24", //审验有效期至
				veocTechLevel: "1", //技术等级评定
				veqcNo: "1", //资质证号
				veqcRegisterDate: "2025-04-09 16:26:24", //发证日期
				veqcStartDate: "2025-04-09 16:26:24", //开始日期
				veqcExpirationDate: "2025-04-09 16:26:24", //产品合格证截止时间
				veinCompany: "1", //保险公司
				veinContact: "1", //联系人
				veinPhone: "1", //联系电话
				veinStartDate: "2025-04-09 16:26:24", //强险开始时间
				veinEndDate: "2025-04-09 16:26:24", //强险到期时间
				veinStartDate1: "2025-04-09 16:26:24", //商业险开始时间
				veinEndDate1: "2025-04-09 16:26:24", //商业险到期时间

				vehOrgdisabled: true,
				files: null,
				isLink: false, //关联招聘
				radio: false,
				selectData: null,
				rptUserId: null, //
				tableData: [],
				totalCount: 0,
				currentPage: 1,
				searchWord: "",
				pageSize: 5,
				bcFlag: "01",
				isZpt: null, //是否是子平台
				rptHongStartTime: "",
				disabledDate: (time) => {
					// 禁用日期
					let nowData = new Date();
					nowData = new Date(nowData.setDate(nowData.getDate() - 1));
					return time < nowData;
				},
				rptHongEndTime: "",
				hDay: null, //红利期区间
				disabledDate1: (time) => {
					// 禁用日期
					let nowData = new Date();
					nowData = new Date(nowData.setDate(nowData.getDate() - 1));
					return time < nowData;
				},
				userNickname: "",
				coverPhoto: "", //详情封面照
				isShowTips: false,
				defaultPsw: "",
				rptParlour: '', //店铺
				shopList: [],
				linkSearch: '',
			};
		},
		methods: {
			veineditChange(value) {
				this.veinedit = value;
				this.veineditisReadOnly = !value;
			},
			veqceditChange(value) {
				this.veqcedit = value;
				this.veqceditisReadOnly = !value;
			},
			veoceditChange(value) {
				this.veocedit = value;
				this.veoceditisReadOnly = !value;
			},
			vedleditChange(value) {
				this.vedledit = value;
				this.vedleditisReadOnly = !value;
			},
			veheditChange(value) {
				this.vehedit = value;
				this.veheditisReadOnly = !value;

				if (value) {
					if (this.vehSource == "0") {
						this.vehOrgdisabled = true;
					} else {
						this.vehOrgdisabled = false;
					}
				} else {
					this.vehOrgdisabled = true;
				}

			},
			//商业险证
			uploadveinPhotoUrl1(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.veinPhotoUrl1.indexOf("https://") !== -1) {
						this.removeImgUrl(this.veinPhotoUrl1);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "veinPhotoUrl1");
				});
			},
			//强险证
			uploadveinPhotoUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.veinPhotoUrl.indexOf("https://") !== -1) {
						this.removeImgUrl(this.veinPhotoUrl);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "veinPhotoUrl");
				});
			},
			//合格证
			uploadveqcPhotoUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.veqcPhotoUrl.indexOf("https://") !== -1) {
						this.removeImgUrl(this.veqcPhotoUrl);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "veqcPhotoUrl");
				});
			},
			//道路运输证
			uploadveocPhotoUrl(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.veocPhotoUrl.indexOf("https://") !== -1) {
						this.removeImgUrl(this.veocPhotoUrl);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "veocPhotoUrl");
				});
			},
			//行驶证正面
			uploadvedlFrontPic(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.vedlFrontPic.indexOf("https://") !== -1) {
						this.removeImgUrl(this.vedlFrontPic);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "vedlFrontPic");
				});
			},
			//行驶证背面
			uploadvedlBackPic(file) {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;

				if (isLt2M == false) {
					this.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (this.vedlBackPic.indexOf("https://") !== -1) {
						this.removeImgUrl(this.vedlBackPic);
					}
					this.upLoadBase64uploadToOSS(imageUrl, "vedlBackPic");
				});
			},
			//上传图片
			upLoadBase64uploadToOSS(imageUrl, type) {
				this.$http
					.post("/api/ossUpload/base64Json", {
						name: imageUrl,
						value: "123",
					})
					.then((res) => {
						// if(res.)
						this[type] = res;
					});
			},
			//删除图片
			removeImgUrl(imageUrl) {
				this.$http
					.get("/biz/bdzl/rptInfo/removeUrl", {
						url: imageUrl
					})
					.then((res) => {});
			},
			//保存基本信息
			veheditsave() {
				if (this.vehNo == "") {
					this.$message.error("请填写牵引车车牌号");
					return;
				}
				if (this.vehPhone == "") {
					this.$message.error("请填写车载电话");
					return;
				}

				let sendData = {
					vehId: this.selectvehId,
					vehOrg: this.vehOrg,
					vehType: this.vehType,
					vehFlag: this.vehFlag,
					vehAffOrg: this.vehAffOrg,
					vehAffOrgType: this.vehAffOrgType,
					vehNo: this.vehNo,
					vehNoColour: '2',
					vehNoType: '2',
					vehColour: this.vehColour,
					vehSource: this.vehSource,
					vehAxleNum: this.vehAxleNum,
					vehEnginePower: this.vehEnginePower,
					vehLenght: this.vehLenght,
					vehWidth: this.vehWidth,
					vehHeight: this.vehHeight,
					vehMaxVolume: this.vehMaxVolume,
					vehWheelbase: this.vehWheelbase,
					vehEmission: '2',
					vehFuelType: this.vehFuelType,
					vehRiskType: this.vehRiskType,
					vehPhone: this.vehPhone,
					vehPiezometerNum: this.vehPiezometerNum,
					vehSafetyValveNum: this.vehSafetyValveNum,
					vehRemark: this.vehRemark
				};

				console.log(this.sendData);
				this.$http.post("/biz/bdzl/vehInfo/update", sendData).then((res) => {
					if (res.respCode == "0000") {
						this.$message.success(res.respMsg);
						// this.getData();
						// this.closeModal();
						this.veheditChange(false);
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},
			//保存行驶证信息
			vedleditsave() {
				let sendData = {
					vehId: this.selectvehId,
					drivingLicense: {
						vedlType: this.vedlType,
						vedlOwner: this.vedlOwner,
						vedlAddress: this.vedlAddress,
						vedlUseCharacter: this.vedlUseCharacter,
						vedlBrand: this.vedlBrand,
						vedlSeries: this.vedlSeries,
						vedlModel: this.vedlModel,
						vedlFrameNo: this.vedlFrameNo,
						vedlEngineNo: this.vedlEngineNo,
						vedlRegisterDate: this.vedlRegisterDate,
						vedlIssueDate: this.vedlIssueDate,
						vedlFileNo: this.vedlFileNo,
						vedlSeats: this.vedlSeats,
						vedlGrossWeight: this.vedlGrossWeight,
						vedlCurbWeight: this.vedlCurbWeight,
						vedlCarringWeight: this.vedlCarringWeight,
						vedlTowWeight: this.vedlTowWeight,
						vedlCargoLength: this.vedlCargoLength,
						vedlCargoWidht: this.vedlCargoWidht,
						vedlCargoHeight: this.vedlCargoHeight,
						vedlFrontPic: this.vedlFrontPic,
						vedlBackPic: this.vedlBackPic,
						vedlRemark: null,
						vedlScrappingDate: this.vedlScrappingDate,
						vedlExpirationDate: this.vedlExpirationDate
					}
				};

				console.log(this.sendData);
				this.$http.post("/biz/bdzl/vehInfo/updateVehDL", sendData).then((res) => {
					if (res.respCode == "0000") {
						this.$message.success(res.respMsg);
						// this.getData();
						// this.closeModal();
						this.vedleditChange(false);
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},
			//保存道路运输证
			veoceditsave() {
				let sendData = {
					vehId: this.selectvehId,
					operationCertificate: {
						veocVehId: 1,
						veocTransportLicense: this.veocTransportLicense,
						veocAffCom: this.veocAffCom,
						veocComAddr: this.veocComAddr,
						veocBusiLicense: this.veocBusiLicense,
						veocVehType: this.veocVehType,
						veocTonnage: this.veocTonnage,
						veocBusiScope: this.veocBusiScope,
						veocVehSize: this.veocVehSize,
						veocRegisterDate: this.veocRegisterDate,
						veocExpirationDate: this.veocExpirationDate,
						veocInstitutionSeal: this.veocInstitutionSeal,
						veocVerificationDate: this.veocVerificationDate,
						veocTechLevel: this.veocTechLevel,
						veocPhotoUrl: this.veocPhotoUrl
					}
				};

				console.log(this.sendData);
				this.$http.post("/biz/bdzl/vehInfo/updateVehOC", sendData).then((res) => {
					if (res.respCode == "0000") {
						this.$message.success(res.respMsg);
						// this.getData();
						// this.closeModal();
						this.veoceditChange(false);
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},
			//保存产品合格证
			veqceditsave() {
				let sendData = {
					vehId: this.selectvehId,
					qualificationCertificate: {
						veqcNo: this.veqcNo,
						veqcRegisterDate: this.veqcRegisterDate,
						veqcStartDate: this.veqcStartDate,
						veqcExpirationDate: this.veqcExpirationDate,
						veqcPhotoUrl: this.veqcPhotoUrl
					}
				};

				console.log(this.sendData);
				this.$http.post("/biz/bdzl/vehInfo/updateVehQC", sendData).then((res) => {
					if (res.respCode == "0000") {
						this.$message.success(res.respMsg);
						// this.getData();
						// this.closeModal();
						this.veqceditChange(false);
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},
			//保存保险保单图片
			veineditsave() {
				let sendData = {
					vehId: this.selectvehId,
					insuranceList: [{
							veinFlag: '0',
							veinCompany: this.veinCompany,
							veinContact: this.veinContact,
							veinPhone: this.veinPhone,
							veinStartDate: this.veinStartDate,
							veinEndDate: this.veinEndDate,
							veinPhotoUrl: this.veinPhotoUrl
						},
						{
							veinFlag: '1',
							veinCompany: this.veinCompany,
							veinContact: this.veinContact,
							veinPhone: this.veinPhone,
							veinStartDate: this.veinStartDate1,
							veinEndDate: this.veinEndDate1,
							veinPhotoUrl: this.veinPhotoUrl1
						}
					]
				};

				console.log(this.sendData);
				this.$http.post("/biz/bdzl/vehInfo/updateVehInsurance", sendData).then((res) => {
					if (res.respCode == "0000") {
						this.$message.success(res.respMsg);
						// this.getData();
						// this.closeModal();
						this.veineditChange(false);
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},


			getDetail() {
				let params = {
					vehId: this.selectvehId,
				};
				this.$http.get("/biz/bdzl/vehInfo/edit", params).then((res) => {
					if (res.respCode === "0000") {
						this.vehOrg = res.vehInfo.vehOrg;
						this.vehType = res.vehInfo.vehType;
						this.vehFlag = res.vehInfo.vehFlag;
						this.vehAffOrg = res.vehInfo.vehAffOrg;
						this.vehAffOrgType = res.vehInfo.vehAffOrgType;
						this.vehNo = res.vehInfo.vehNo;
						this.vehColour = res.vehInfo.vehColour;
						this.vehSource = res.vehInfo.vehSource;
						this.vehAxleNum = res.vehInfo.vehAxleNum;
						this.vehEnginePower = res.vehInfo.vehEnginePower;
						this.vehLenght = res.vehInfo.vehLenght;
						this.vehWidth = res.vehInfo.vehWidth;
						this.vehHeight = res.vehInfo.vehHeight;
						this.vehMaxVolume = res.vehInfo.vehMaxVolume;
						this.vehWheelbase = res.vehInfo.vehWheelbase;
						this.vehFuelType = res.vehInfo.vehFuelType;
						this.vehRiskType = res.vehInfo.vehRiskType;
						this.vehPhone = res.vehInfo.vehPhone;
						this.vehPiezometerNum = res.vehInfo.vehPiezometerNum;
						this.vehSafetyValveNum = res.vehInfo.vehSafetyValveNum;
						this.vehRemark = res.vehInfo.vehRemark;
						this.vedlType = res.vehInfo.drivingLicense.vedlType;
						this.vedlOwner = res.vehInfo.drivingLicense.vedlOwner;
						this.vedlAddress = res.vehInfo.drivingLicense.vedlAddress;
						this.vedlUseCharacter = res.vehInfo.drivingLicense.vedlUseCharacter;
						this.vedlBrand = res.vehInfo.drivingLicense.vedlBrand;
						this.vedlSeries = res.vehInfo.drivingLicense.vedlSeries;
						this.vedlModel = res.vehInfo.drivingLicense.vedlModel;
						this.vedlFrameNo = res.vehInfo.drivingLicense.vedlFrameNo;
						this.vedlEngineNo = res.vehInfo.drivingLicense.vedlEngineNo;
						this.vedlRegisterDate = res.vehInfo.drivingLicense.vedlRegisterDate;
						this.vedlIssueDate = res.vehInfo.drivingLicense.vedlIssueDate;
						this.vedlFileNo = res.vehInfo.drivingLicense.vedlFileNo;
						this.vedlSeats = res.vehInfo.drivingLicense.vedlSeats;
						this.vedlGrossWeight = res.vehInfo.drivingLicense.vedlGrossWeight;
						this.vedlCurbWeight = res.vehInfo.drivingLicense.vedlCurbWeight;
						this.vedlCarringWeight = res.vehInfo.drivingLicense.vedlCarringWeight;
						this.vedlTowWeight = res.vehInfo.drivingLicense.vedlTowWeight;
						this.vedlCargoLength = res.vehInfo.drivingLicense.vedlCargoLength;
						this.vedlCargoWidht = res.vehInfo.drivingLicense.vedlCargoWidht;
						this.vedlCargoHeight = res.vehInfo.drivingLicense.vedlCargoHeight;
						this.vedlFrontPic = res.vehInfo.drivingLicense.vedlFrontPic;
						this.vedlBackPic = res.vehInfo.drivingLicense.vedlBackPic;
						this.vedlRemark = res.vehInfo.drivingLicense.vedlRemark;
						this.vedlScrappingDate = res.vehInfo.drivingLicense.vedlScrappingDate;
						this.vedlExpirationDate = res.vehInfo.drivingLicense.vedlExpirationDate;
						this.veocTransportLicense = res.vehInfo.operationCertificate.veocTransportLicense;
						this.veocAffCom = res.vehInfo.operationCertificate.veocAffCom;
						this.veocComAddr = res.vehInfo.operationCertificate.veocComAddr;
						this.veocBusiLicense = res.vehInfo.operationCertificate.veocBusiLicense;
						this.veocVehType = res.vehInfo.operationCertificate.veocVehType;
						this.veocTonnage = res.vehInfo.operationCertificate.veocTonnage;
						this.veocBusiScope = res.vehInfo.operationCertificate.veocBusiScope;
						this.veocVehSize = res.vehInfo.operationCertificate.veocVehSize;
						this.veocRegisterDate = res.vehInfo.operationCertificate.veocRegisterDate;
						this.veocExpirationDate = res.vehInfo.operationCertificate.veocExpirationDate;
						this.veocInstitutionSeal = res.vehInfo.operationCertificate.veocInstitutionSeal;
						this.veocVerificationDate = res.vehInfo.operationCertificate.veocVerificationDate;
						this.veocTechLevel = res.vehInfo.operationCertificate.veocTechLevel;
						this.veocPhotoUrl = res.vehInfo.operationCertificate.veocPhotoUrl;
						this.veqcNo = res.vehInfo.qualificationCertificate.veqcNo;
						this.veqcRegisterDate = res.vehInfo.qualificationCertificate.veqcRegisterDate;
						this.veqcStartDate = res.vehInfo.qualificationCertificate.veqcStartDate;
						this.veqcExpirationDate = res.vehInfo.qualificationCertificate.veqcExpirationDate;
						this.veqcPhotoUrl = res.vehInfo.qualificationCertificate.veqcPhotoUrl;
						res.vehInfo.insuranceList.forEach((item) => {
							if (item.veinFlag == "0") {
								this.veinCompany = item.veinCompany;
								this.veinContact = item.veinContact;
								this.veinPhone = item.veinPhone;
								this.veinStartDate = item.veinStartDate;
								this.veinEndDate = item.veinEndDate;
								this.veinPhotoUrl = item.veinPhotoUrl;
							} else if (item.veinFlag == "1") {
								this.veinCompany = item.veinCompany;
								this.veinContact = item.veinContact;
								this.veinPhone = item.veinPhone;
								this.veinStartDate1 = item.veinStartDate;
								this.veinEndDate1 = item.veinEndDate;
								this.veinPhotoUrl1 = item.veinPhotoUrl;
							}
						});

						// setTimeout(() => {
						// 	this.lookImg();
						// }, 1500);
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},

			getvedlRegisterDate(ev) {
				this.vedlRegisterDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.vedlRegisterDate);
			},
			getvedlIssueDate(ev) {
				this.vedlIssueDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.vedlIssueDate);
			},
			getvedlExpirationDate(ev) {
				this.vedlExpirationDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.vedlExpirationDate);
			},
			getvedlScrappingDate(ev) {
				this.vedlScrappingDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.vedlScrappingDate);
			},
			getveocRegisterDate(ev) {
				this.veocRegisterDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veocRegisterDate);
			},
			getveocExpirationDate(ev) {
				this.veocExpirationDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veocExpirationDate);
			},
			getveocVerificationDate(ev) {
				this.veocVerificationDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veocVerificationDate);
			},
			getveqcRegisterDate(ev) {
				this.veqcRegisterDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veqcRegisterDate);
			},
			getveqcStartDate(ev) {
				this.veqcStartDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veqcStartDate);
			},
			getveqcExpirationDate(ev) {
				this.veqcExpirationDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veqcExpirationDate);
			},
			getveinStartDate(ev) {
				this.veinStartDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veinStartDate);
			},
			getveinEndDate(ev) {
				this.veinEndDate = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veinEndDate);
			},
			getveinStartDate1(ev) {
				this.veinStartDate1 = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veinStartDate1);
			},
			getveinEndDate1(ev) {
				this.veinEndDate1 = parseTime(ev, "{y}-{m}-{d}");
				console.log(this.veinEndDate1);
			},

			//获取所属客商
			getProviderList() {
				let params = {
					page: 1,
					limit: 10000,
				};
				this.$http.get(apiObj.cusList, params).then((res) => {
					if (res.code == 0) {
						this.ProviderList = res.rows;
					} else {
						this.$message.error(res.respMsg);
					}
				});
			},

			vehSourcechange() {
				if (this.vehSource == "0") {
					this.vehAffOrg = "";
					this.vehAffOrgType = "1";
					this.vehOrgdisabled = true;
				} else {
					this.vehAffOrg = "";
					this.vehAffOrgType = "0";
					this.vehOrgdisabled = false;
				}
			},

			//查看图片
			lookImg() {
				// const refvedlDom = this.$refs.refvedl;
				// if (refvedlDom != undefined) {
				// 	const zfhtViewer = new Viewer(refvedlDom, {
				// 		url: "data-original",
				// 	});
				// }
			},

			openViewer(typeindex) {
				let refvedlDom = null;
				if (typeindex == "vedl") {
					if (!this.vedleditisReadOnly) {
						if (this.viewer) {
							this.viewer.destroy();
						}
						return;
					} else {
						refvedlDom = this.$refs.refvedl;
					}
				} else if (typeindex == "veoc") {
					if (!this.veoceditisReadOnly) {
						if (this.viewer) {
							this.viewer.destroy();
						}
						return;
					} else {
						refvedlDom = this.$refs.refveoc;
					}
				} else if (typeindex == "veqc") {
					if (!this.veqceditisReadOnly) {
						if (this.viewer) {
							this.viewer.destroy();
						}
						return;
					} else {
						refvedlDom = this.$refs.refveqc;
					}
				} else if (typeindex == "vein") {
					if (!this.veineditisReadOnly) {
						if (this.viewer) {
							this.viewer.destroy();
						}
						return;
					} else {
						refvedlDom = this.$refs.refvein;
					}
				} else {
					return;
				}

				// 创建新的 Viewer 实例
				this.$nextTick(() => {
					// 如果已经有 Viewer 实例，则先销毁
					if (this.viewer) {
						this.viewer.destroy();
					}

					// if (refvedlDom != undefined) {
					// 	this.viewer = new Viewer(refvedlDom, {
					// 		url: "data-original",
					// 	});
					// }
					if (refvedlDom != undefined) {
						this.viewer = new Viewer(refvedlDom, {
							inline: false, // 不使用内联模式，强制弹出（使用内联样式就会在页面展示，不弹出）
							navbar: true, // 显示导航
							title: false, // 隐藏标题
							toolbar: true, // 显示工具栏
							zoomable: true, // 支持缩放
							rotatable: true, // 支持旋转
							scalable: true, // 支持缩放
							transition: true, // 启用过渡效果
						});
						// 显示图片
						this.viewer.show();
					}
				});

			},

		},
		watch: {},
		setup(props, context) {
			const {
				proxy
			} = getCurrentInstance();

			const closeModal = () => {
				context.emit("closeModal");
			};

			const getData = () => {
				context.emit("getData");
			};

			const data = reactive({
				selectvehId: "",

			});

			onMounted(() => {
				console.log(props.sendData.vehId);
				data.selectvehId = props.sendData.vehId;
				console.log("bianji");
			});

			return {
				...toRefs(data),
				closeModal,
				getData,
			};
		},
		created() {},
		mounted() {
			// var date = new Date();
			// var y = date.getFullYear();
			// var month = date.getMonth() + 1;
			// if (month < 10) {
			// 	month = "0" + month;
			// }
			// var day = date.getDate();
			// if (day < 10) {
			// 	day = "0" + day;
			// }
			// this.rptHongStartTime = y + "-" + month + "-" + day;
			// console.log(day);
			this.getDetail();
			this.getProviderList();
		},
	};
</script>

<style scoped>
	#AddConvalescePeople {
		/* background: #f6fffb; */
		overflow: auto;
		padding-top: 20px;
	}

	:deep(.el-table__header .el-table-column--selection .cell .el-checkbox) {
		display: none;
	}

	:deep(.el-table-column--selection .cell) {
		text-align: center;
	}

	:deep(.el-checkbox__input .el-checkbox__inner) {
		border-radius: 50%;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100%;
	}

	.el-input--prefix .el-input__inner {
		padding-left: 30px !important;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #5cc95e;
		cursor: pointer;
		width: 120px;
		text-align: right;
	}

	.box-right-row {
		display: flex;
		align-items: center;
	}

	.img-box {
		width: 460px;
		height: 280px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		display: flex;
		flex-wrap: wrap;
		padding-top: 20px;
	}

	.image-box-item {
		width: 120px;
		height: 120px;
		margin-left: 20px;
		margin-right: 10px;
		margin-bottom: 20px;
		position: relative;
	}

	.image-box-item-upload {
		width: 120px;
		height: 120px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.image-box-item-upload .upload-icon {
		width: 30px;
		height: 30px;
	}

	.bank-img-box {
		width: 460px;
		height: 176px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 20px;
	}

	.bank-img-box-font {
		width: 178px;
		height: 120px;
		background: #f9f9f9;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-right: 20px;
	}

	.img-common-img-box {
		width: 478px;
		height: 181px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 20px;
	}

	.btn-box {
		width: 100%;
		height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #ffffff;
	}

	.cancel {
		width: 90px;
		height: 30px;
		background: #ffffff;
		border: 1px solid #e5e5e5;
		border-radius: 6px;
		font-size: 14px;
		color: #333333;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
	}

	.confirm {
		width: 90px;
		height: 30px;
		background: #2eb779;
		border: 1px solid #2eb779;
		border-radius: 6px;
		font-size: 14px;
		color: #fff;
		margin-left: 30px;
		text-align: center;
		line-height: 30px;
		cursor: pointer;
	}

	:deep(.input_box .el-input) {
		width: 100%;
	}

	.m-top10 {
		margin-top: 10px;
	}

	.m-top20 {
		margin-top: 20px;
	}

	.rpt_warp {
		width: 100%;
		background: #fff;
	}

	.rpt_tit {
		width: 100%;
		height: 70px;
		border-bottom: 1px solid #eeeeee;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 42px;
	}

	.rpt_box1 {
		width: 100%;
		height: 240px;
	}

	.pic-box {
		display: flex;

		margin-left: 42px;
	}

	.pic {
		width: 120px;
		height: 120px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.pic .upload-icon {
		width: 54px;
		height: 54px;
	}

	.pic .userHeadImg {
		width: 154px;
		height: 154px;
	}

	.identity-card {
		display: flex;
		margin-left: 50px;
	}

	.identity {
		width: 227px;
		height: 150px;
		margin-left: 10px;
		margin-right: 40px;
	}

	.identity img {
		width: 227px;
		height: 150px;
	}

	.rpt_box2 {
		width: 100%;
		padding-top: 30px;
		padding-bottom: 30px;
	}

	.input_row {
		width: 90%;
		margin-left: 1%;
		height: 38px;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
	}

	.input_row2 {
		width: 95%;
		margin-left: 1%;
		height: 88px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-between;
	}

	.input_cell {
		width: 33%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.input_cell2 {
		width: 33%;
		height: 150px;
		display: flex;
		align-items: center;
	}

	.input_cell .label {
		width: 148px;
		text-align: right;
	}

	.input_box {
		flex: 1;
		height: 100%;
		margin-left: 30px;
		display: flex;
		align-items: center;
	}

	.rpt_box3 {
		width: 100%;
		height: 286px;
		justify-content: space-between;
	}

	.rpic_img_warp {
		margin-left: 62px;
	}

	.rpic_img_box {
		width: 479px;
		height: 200px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		flex-wrap: wrap;
	}

	.rpic_img_box2 {
		width: 200px;
		height: 200px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 10px;
		display: flex;
		align-items: flex-start;
	}

	.upRpic_icon_item {
		margin-top: 20px;
		width: 125px;
		height: 60px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic_icon_item2 {
		margin-top: 0px;
		width: 125px;
		height: 125px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic2_icon {
		/* width: 125px;
		height: 125px; */
		width: 80%;
		hieght: auto;
	}

	.upRpic_icon {
		width: 20px;
		height: 20px;
	}

	.image-box-item-del {
		position: absolute;
		right: 0;
		top: 0;
		width: 20px;
		height: 20px;
		cursor: pointer;
	}

	.image-box-item-del img {
		width: 20px;
		height: 20px;
	}

	.rpic_img_text {
		width: 100px;
		height: 200px;
		display: flex;
		flex-direction: column;
		align-content: center;
		justify-content: center;
	}

	.cretUrl_img_warp {
		height: 181px;
	}

	.cretUrl_img_box {
		width: 360px;
		height: 180px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 30px;
	}

	.rpt_box4 {
		width: 98%;
		margin-left: 1%;
		padding: 30px 0;
		border-bottom: 1px solid #eeeeee;
	}

	.rpt_bank_info {
		width: 50%;
	}

	.rpt_bank_row {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.rpt_bank_lable {
		width: 148px;
		text-align: right;
	}

	.bank_input_box {
		width: 500px;
		margin-left: 20px;
	}

	.rpt_bank_img_warp {
		width: 50%;
		display: flex;
		margin-right: 30px;
	}

	.bank_card_img_warp {
		width: 478px;
		height: 176px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.conName_input {
		border: none;
		outline: none;
		flex: 1;
		padding-left: 10px;
	}

	.fuzi {
		width: 35px;
		height: 16px;
		background: #20ca68;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 12px;
		color: #fff;
		padding: 0 5px;
	}

	.serach_btn {
		width: 87px;
		height: 38px;
		background: #2EB779;
		border-radius: 6px;
		text-align: center;
		line-height: 38px;
		color: #fff;
		cursor: pointer;
		margin-left: 20px;
	}

	.menu_warp {
		width: 100%;
		height: 100%;
		background: #f5f5f4;
		overflow: auto;
	}

	.tit_warp {
		width: 100%;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		margin-bottom: 20px;
		height: 42px;
		line-height: 42px;
		font-size: 14px;
		color: #333;
		overflow: hidden;
		background-color: #fff;
		border-radius: 2px 2px 0 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.header_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
	}

	.editimg {
		width: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}
</style>